module.exports = __webpack_public_path__ + "img/sem-imagem.c9a473ff.jpg";